import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

interface ErrorStateProps {
  title?: string;
  body?: string;
  onRetry?: () => void;
}

/**
 * Designed error state (foundations.md §7.13): icon, plain-language
 * headline, generic explanation (never a raw error code or stack detail —
 * see technology concealment), and a recovery action.
 */
export function ErrorState({ title, body, onRetry }: ErrorStateProps) {
  const translate = useTranslate();

  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 8, px: 3, textAlign: 'center' }}>
      <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
      <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>
        {title ?? translate('pay.errorState.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {body ?? translate('pay.errorState.body')}
      </Typography>
      {onRetry && (
        <Button variant="outlined" onClick={onRetry}>
          {translate('pay.errorState.retry')}
        </Button>
      )}
    </Stack>
  );
}
